

const ImportTitle = ({ title, description, note }) => {
    return (
        <>
            <h2 className="text-2xl font-semibold mb-2">{title}</h2>
            <p className="text-gray-600 mb-4">{description}</p>
            <p className="text-primary mb-6">
                {note || 'Note: You can make any changes to your selected items after importing your profile.'}
            </p>
        </>
    )
}

export default ImportTitle;
